// ** React Imports
import { useState, Fragment } from "react";

// ** Reactstrap Imports
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Button,
  ListGroup,
  ListGroupItem,
} from "reactstrap";

// ** Third Party Imports
import { ReactComponent as UploadIcon } from "@src/assets/images/icons/upload.svg";

import { useDropzone } from "react-dropzone";
import { FileText, X, DownloadCloud } from "react-feather";

const FileUploaderSingle = ({ value, onChange, image, format }) => {
  const { getRootProps, getInputProps } = useDropzone({
    accept: image
        ? {
          'image/png': ['.png'],
          'image/jpeg': ['.jpg'],
        }
        : undefined,
    multiple: false,
    onDrop: (acceptedFiles) => {
      // Update the form state with the new file
      onChange(acceptedFiles[0]);
    },
  });

  const renderFilePreview = (file) => {
    if (file?.type?.startsWith("image")) {
      return (
        <img
          className="rounded"
          alt={file.name}
          src={URL.createObjectURL(file)}
          height="28"
          width="28"
        />
      );
    } else {
      return <FileText size="28" />;
    }
  };

  const handleRemoveFile = () => {
    // Clear the file
    onChange(null);
  };

  const renderFileSize = (size) => {
    if (Math.round(size / 100) / 10 > 1000) {
      return `${(Math.round(size / 100) / 10000).toFixed(1)} mb`;
    } else {
      return `${(Math.round(size / 100) / 10).toFixed(1)} kb`;
    }
  };

  return (
    <div className="w-100">
      <div className="w-100" {...getRootProps({ className: "dropzone" })}>
        <input  {...getInputProps()} />
        <div className="d-flex align-items-center justify-content-center flex-column w-100">
          <UploadIcon className="my-1" />
          <p>Insert or drag file into box.</p>
          <small>{format}</small>
        </div>
      </div>
      {value && (
        <ListGroup className="mt-1">
          <ListGroupItem className="d-flex align-items-center justify-content-between">
            <div className="file-details d-flex align-items-center">
              <div className="file-preview me-1">
                {renderFilePreview(value)}
              </div>
              <div>
                <p className="file-name mb-0">{value.name}</p>
                <p className="file-size mb-0">{renderFileSize(value.size)}</p>
              </div>
            </div>
            <Button
              color="danger"
              outline
              size="sm"
              className="btn-icon"
              onClick={handleRemoveFile}
            >
              <X size={14} />
            </Button>
          </ListGroupItem>
        </ListGroup>
      )}
    </div>
  );
};

export default FileUploaderSingle;
